export default [
  "decay",
  "provisionalRestoration",
  "amalgam",
  "nonMetallicRestoration",
  "metallicRestoration",
  "abrasion",
  "fractureSurface",
];
